import type { MetaReducer } from '@ngrx/store';
import { NGRX_STORAGE_KEYS } from '../../../core/store/ngrx-persisted-state.keys';
import { createStorageSyncMetaReducer } from '../../../core/store/ngrx-storage-sync.meta-reducer';
import { QuickApplicationState } from './quick-application.models';
import { quickApplicationFeature } from './quick-application.reducer';

function toSerializableQuickApplicationState(state: QuickApplicationState): QuickApplicationState {
  if (!state.formValue?.applicationForm?.applications) {
    return state;
  }

  const serializableApplications = state.formValue.applicationForm.applications.map((application) => ({
    ...application,
    coverLetter: null,
    _coverLetterFile: null
  }));

  return {
    ...state,
    formValue: {
      ...state.formValue,
      applicationForm: {
        ...state.formValue.applicationForm,
        applications: serializableApplications
      }
    }
  };
}

function shouldClearFromStorage(state: QuickApplicationState): boolean {
  return !state.formValue;
}

function parseQuickApplicationState(raw: unknown): QuickApplicationState | null {
  return raw && typeof raw === 'object' ? (raw as QuickApplicationState) : null;
}

export const quickApplicationMetaReducers: MetaReducer[] = [
  createStorageSyncMetaReducer<QuickApplicationState>({
    featureKey: quickApplicationFeature.name,
    storageKey: NGRX_STORAGE_KEYS.quickApplication,
    shouldClearFromStorage,
    serialize: toSerializableQuickApplicationState,
    deserialize: parseQuickApplicationState
  })
];
